import { api } from "@/api";

export const deliverySlipStore = {
  state: {
    deliverySlips: [],
    deliverySlipTemplates: []
  },
  getters: {
    getDeliverySlips(state) {
      return state.deliverySlips;
    },
    getDeliverySlipTemplates(state) {
      return state.deliverySlipTemplates;
    }
  },
  mutations: {
    setDeliverySlips(state, value) {
      state.deliverySlips = value;
    },
    addDeliverySlip(state, value) {
      state.deliverySlips.push(value);
    },
    setDeliverySlipTemplates(state, value) {
      state.deliverySlipTemplates = value;
    },
    addDeliverySlipTemplate(state, value) {
      state.deliverySlipTemplates.push(value);
    }
  },
  actions: {
    async loadDeliverySlips(context, payload) {
      const res = await api.getDeliverySlips(payload);
      context.commit("setDeliverySlips", res);
    },
    async addDeliverySlip(context, payload) {
      const res = await api.postDeliverySlip(payload);
      if (res) {
        context.commit("addDeliverySlip", res);
      }
    },
    async loadDeliverySlipTemplates(context, payload) {
      const res = await api.getDeliverySlipTemplates(payload);
      context.commit("setDeliverySlipTemplates", res);
    },
    async addDeliverySlipTemplate(context, payload) {
      const res = await api.postDeliverySlipTemplate(payload);
      if (res) {
        context.commit("addDeliverySlipTemplate", res);
      }
    }
  }
};
